import React, { ReactNode } from "react";
import { StarterRoutePath } from "./_starter.route-path";
const StarterDashboard = React.lazy(
  () => import("../features/dashboard/StarterDashboard"),
);
const StarterNotFoundError = React.lazy(
  () => import("../features/errors/StarterNotFoundError"),
);
const StarterInternalServerError = React.lazy(
  () => import("../features/errors/StarterInternalServerError"),
);

export type route = {
  component?: ReactNode;
  name?: string;
  path?: string;
  routes?: route[];
  paramIndex?: number;
  disabled?: undefined | boolean;
};

const starterRoutes = [
  { path: StarterRoutePath.Home, name: "Home" },
  {
    path: StarterRoutePath.Dashboard,
    name: "Dashboard",
    component: StarterDashboard,
  },
  {
    path: StarterRoutePath.NotFoundError,
    name: "Page Not Found",
    component: StarterNotFoundError,
  },
  {
    path: StarterRoutePath.InternalServerError,
    name: "Internal Server Error",
    component: StarterInternalServerError,
  },
];

export default starterRoutes;
